var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Transition",
    {
      attrs: { name: "recap-dialog-transition" },
      on: { "after-enter": _vm.handleOpenModal }
    },
    [
      _vm.visible
        ? _c("div", { staticClass: "recap-dialog" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible"
                  }
                ],
                ref: "overlay",
                staticClass: "recap-dialog__overlay",
                attrs: { tabindex: "-1" },
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.handleCloseDialog(true)
                  },
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    return _vm.handleCloseDialog($event)
                  }
                }
              },
              [
                _c(
                  "Transition",
                  {
                    attrs: { name: "recap-dialog-modal-transition" },
                    on: { "after-leave": _vm.handleCloseDialog }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.localValue,
                            expression: "localValue"
                          }
                        ],
                        ref: "modal",
                        staticClass: "recap-dialog__modal",
                        attrs: { tabindex: "-1" },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape"
                              ])
                            ) {
                              return null
                            }
                            return _vm.handleCloseDialog($event)
                          }
                        }
                      },
                      [
                        _c("CompassIconButton", {
                          staticClass: "recap-dialog__close",
                          attrs: {
                            "data-bot": "recap-dialog__close",
                            icon: "close"
                          },
                          on: { click: _vm.handleCloseDialog }
                        }),
                        _vm._v(" "),
                        _c("h2", { staticClass: "recap-dialog__title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t.__(
                                  "recap.slider.IntroductionSlide.title"
                                )
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "recap-dialog__image",
                          attrs: {
                            src:
                              "/ressources/logged/img/illustrations/recap2024/shape-recap.svg",
                            width: "277"
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("recap.RecapDialog.button"),
                            type: "secondary-contrast",
                            size: "large"
                          },
                          on: { click: _vm.goToRecap }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }